import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['contactSalesMqlClicked'] as const;

export const abTestEvents = getMappedEvents([...EVENTS]);
